import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { AltTextPipe } from 'render/render-shared/alt-text/alt-text.pipe';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderProductPricesModule } from 'render/render-shared/ui/render-product-prices/render-product-prices.module';
import { RenderProductPurchaseOptionsModule } from 'render/render-shared/ui/render-product-sizes/render-product-purchase-options.module';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceProductBannerRenderComponent } from './piece-product-banner-render.component';


export const pieceProductBannerRenderModuleEntryComponents = [
  PieceProductBannerRenderComponent
];

@NgModule({
  imports: [
    AltTextPipe,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    LazyLoadModule,
    RenderProductPricesModule,
    RenderProductPurchaseOptionsModule
  ],
  providers: [
    RenderStateService
  ],
  declarations: pieceProductBannerRenderModuleEntryComponents
})
export class PieceProductBannerRenderModule {}

export default pieceProductBannerRenderModuleEntryComponents;
